<script>
	const Q = require('q');
	const utilities = require('utilities');
	const { closeAssignment } = require('utilities/assignmentUtilities');
	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const SHOW_CLOSE_DISMISS = accountSettingsUtilities.settings.SHOW_CLOSE_DISMISS;
	const { beginAssignmentAction, endAssignmentAction } = require('utilities/assignmentUtilities');

	module.exports = {
		components: {
			modal: require('./modal.vue').default
		},
		data() {
			return {
				assignment: null,
				showCloseDismiss: null,
				loading: false
			};
		},
		methods: {
			dismissShowResultsModal() {
				this.loading = true;
				accountSettingsUtilities
					.update(SHOW_CLOSE_DISMISS, true)
					.then(() => this.onClose())
					.then(() => this.closeModals())
					.finally(() => {
						this.loading = false;
					});
				this.showCloseDismiss = true;
			},
			closeModals() {
				utilities.closeModals();
			},
			onClose() {
				let assignment = this.assignment;
				this.loading = true;
				beginAssignmentAction();
				return closeAssignment(assignment)
					.then(() => this.closeModals())
					.finally(() => {
						endAssignmentAction();
						this.loading = false;
					});
			},
			checkSetting() {
				return accountSettingsUtilities.read(SHOW_CLOSE_DISMISS).then(value => {
					let v = !!value;
					this.showCloseDismiss = v;
					return v;
				});
			}
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-close-assignment') {
					return true; // let some other handler take this
				}
				let prms = Q();
				this.loading = true;

				if (opts) {
					this.assignment = opts.assignment;
				} else {
					return false;
				}

				if (typeof this.showCloseDismiss !== 'boolean') {
					prms = this.checkSetting();
				}

				prms
					.then(() => {
						if (this.showCloseDismiss) {
							return this.onClose().then(() => this.closeModals());
						}
						return Q();
					})
					.finally(() => {
						this.loading = false;
					});
				return false;
			});

			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-close-assignment') {
					return true; // let some other handler take this
				}
				this.assignment = null;
				return false;
			});
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-close-assignment"
		:loading="loading"
		:ok="false"
		:closeable="!loading"
		:no-auto-close="loading">
		<div slot="header-container">
			<h2>End Assignment</h2>
		</div>
		<div
			class="text-centered"
			slot="content">
			<p>Ending the assignment will force submission for any students who have yet to complete the assignment. The assignment can then be graded.</p>
			<p>
				<button
					class="button -outline"
					@click="onClose">
					Ok
				</button>
			</p>
			<button
				class="button -link -link-muted dismiss font-small"
				@click="dismissShowResultsModal">
				Don't show this message again.
			</button>
		</div>
	</modal>
</template>
